export { default } from './SmoothnessControl';
